import { createStore, applyMiddleware, compose } from 'redux'

import { logicList }  from './logicList'
import { rootReducer, initialState } from './rootReducer'
import { getPersistor, persistRootReducer } from './persistor'

const Logic = require('redux-logic')

/* tslint:disable:no-string-literal */
// Redux chrome extension
const composeEnhancers = window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] || compose
/* tslint:enable:no-string-literal */

export const store = createStore(
  persistRootReducer(rootReducer),
  initialState as any,
  composeEnhancers(applyMiddleware(
    Logic.createLogicMiddleware(logicList),
  ))
)

export const persistor = getPersistor(store)

export { RootState } from './rootReducer'



// WEBPACK FOOTER //
// ./src/store/index.ts